// From APP-93 or https://coolors.co/4d9de0-e15554-e1893f-e1bc29-3bb273-598d91-7768ae-808080

export const ECHARTS_COLORS = [
  '#4d9de0',
  '#3bb273',
  '#e1bc29',
  '#e15554',
  '#598d91',
  '#e1893f',
  '#7768ae',
  '#6c6c6c',
];
